import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { TwcPopupRef, TwcPopupService } from '@topcon/twc-angular';

import { PopupNotValidFilesComponent } from './popup-not-valid-files.component';

export interface FileError {
    name: string;
    errorKey: string;
}

/**
 * Service with the business login related to the invalid files list
 */
@Injectable({ providedIn: 'root' })
export class PopupNotValidFilesService {
    openPopupNotValidFiles$: Subject<FileError[]> = new Subject();
    refPopupNotValidFiles: TwcPopupRef | undefined;

    constructor(private popupService: TwcPopupService) {}

    openPopupNotValidFiles(listFiles: FileError[]): void {
        this.refPopupNotValidFiles = this.popupService.open(PopupNotValidFilesComponent);
        this.openPopupNotValidFiles$.next(listFiles);
    }

    closePopupNotValidFiles(): void {
        this.refPopupNotValidFiles?.close();
    }
}
